// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderApprovalDetailsTotalStyles } from "@insite/content-library/Widgets/OrderApprovalDetails/OrderApprovalDetailsTotal";
import getProp from "@insite/mobius/utilities/getProp";
import { color } from "@keller/XDL/Utilities";
import { css } from "styled-components";

orderApprovalDetailsTotalStyles.cartTotal = {
    container: {
        css: css`
            border: 1px solid ${color("common.ui5")};
            box-shadow: ${getProp("theme.shadows.4")};
        `,
    },
};
